import '.i{position:fixed;}.ssr-plugin'
import '.ay{top:0px;}.ssr-plugin'
import '.b5{left:0px;}.ssr-plugin'
import '.b6{right:0px;}.ssr-plugin'
import '.b7{bottom:0px;}.ssr-plugin'
import '.b8{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.b9{z-index:998;}.ssr-plugin'
import '.ba{transition:opacity 0.3s ease;}.ssr-plugin'
import '.bb{height:100vh;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.bc{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.bd{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.be{justify-content:space-between;}.ssr-plugin'
import '.bf{padding:1.5rem;}.ssr-plugin'
import '.bg{border-bottom:var(--border-default);}.ssr-plugin'
import '.am{flex-shrink:0;}.ssr-plugin'
import '.ap{flex:1;}.ssr-plugin'
import '.bh{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i ay b5 b6 b7 b8 b9 ba"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i ay bb n t bc bd d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d r be bf bg am"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="ap bh bf"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
